module.exports = __webpack_public_path__ + "img/728e6e1.webp";